<template>
  <v-card id="choose-interview">
    <v-card-title>
      {{ $t("chooseInterview.title") }}
    </v-card-title>

    <v-card-text>
      <Markdown :value="$t('chooseInterview.description')" />
    </v-card-text>

    <v-card-actions>
      <v-btn color="secondary" :href="$t('chooseInterview.calendly.url')" target="_blank" rel="noreferrer noopener">
        {{ $t("chooseInterview.calendly.cta") }}
      </v-btn>

      <v-spacer></v-spacer>

      <v-dialog v-model="acceptDialog" persistent max-width="600">
        <template #activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on" class="mr-2">
            {{ $t("chooseInterview.accept.label") }}
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline">
            {{ $t("chooseInterview.accept.confirmation.title") }}
          </v-card-title>

          <v-card-text>
            <Markdown :value="$t('chooseInterview.accept.confirmation.description')" />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="warning" @click="acceptDialog = false">
              {{ $t("chooseInterview.accept.confirmation.cancel") }}
            </v-btn>

            <v-btn color="primary" @click="choose(true)" :loading="loading">
              {{ $t("chooseInterview.accept.confirmation.accept") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="rejectDialog" persistent max-width="600">
        <template #activator="{ on, attrs }">
          <v-btn color="warning" v-bind="attrs" v-on="on">
            {{ $t("chooseInterview.reject.label") }}
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline">
            {{ $t("chooseInterview.reject.confirmation.title") }}
          </v-card-title>

          <v-card-text>
            <Markdown :value="$t('chooseInterview.reject.confirmation.description')" />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="warning" @click="rejectDialog = false">
              {{ $t("chooseInterview.reject.confirmation.cancel") }}
            </v-btn>

            <v-btn color="primary" @click="choose(false)" :loading="loading">
              {{ $t("chooseInterview.reject.confirmation.accept") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import ChooseInterviewMutation from "@/gql/mutations/ChooseInterviewMutation.gql";

export default {
  props: {
    auditPeriod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      acceptDialog: false,
      rejectDialog: false,
    };
  },

  methods: {
    async choose(doInterview) {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: ChooseInterviewMutation,
        variables: {
          id: this.auditPeriod.id,
          doInterview,
        },
      });

      this.acceptDialog = false;
      this.rejectDialog = false;
      this.loading = false;
    },
  },
};
</script>
